import { useState } from 'react';

// import { verifyAddress } from '../../../features/loqate/ManualAddressVerifier';
import cardIcon from '../../../assets/icons/billing/card.svg';
import disabledCardIcon from '../../../assets/icons/billing/disabledCard.svg';
import Button from '../../../shared/components/Button';

import BillingAddressForm from './BillingAddressForm';
import YourDetails from './YourDetails';

const BillingDetails = ({ onContinueToPayment, initialData }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isAddressValid, setIsAddressValid] = useState(false);
    const [isYourDetailsValid, setIsYourDetailsValid] = useState(false);

    // Split initialData into address and yourDetails if possible, or just pass flat.
    // initialData likely has { ...address, ...details }

    // Format helpers if needed, but assuming flat structure works for initial state.
    const [addressData, setAddressData] = useState(initialData || {});
    const [yourDetailsData, setYourDetailsData] = useState(initialData || {});

    // const [verificationErrors, setVerificationErrors] = useState({});
    // const [isVerifying, setIsVerifying] = useState(false);
    const [generalError, setGeneralError] = useState(null);
    const [markPhoneTouched, setMarkPhoneTouched] = useState(false);

    const handleInteraction = () => {
        if (!markPhoneTouched) {
            setMarkPhoneTouched(true);
        }
    };

    const handleContinueToPayment = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        setGeneralError(null);
        // setVerificationErrors({});

        // Merge yourDetails data with address data
        const completeData = {
            ...addressData,
            ...yourDetailsData
        };

        // If the selected address came from the AddressCapture auto-complete, 
        // it's already validated. We check if addressData has properties that imply
        // a completed search vs a fully manual entry.
        // Or simpler, let's track mode if we passed it down, but since we don't,
        // we can check if it has the strict Loqate response structure (e.g. region, line1)
        // rather than empty fields.

        // setIsVerifying(true);
        try {
            // We should only verify if it was manually entered. If line1 and city exist 
            // from the initial dataset, we might still verify it but let's assume if 
            // we have state/region we're mostly good, but to be robust:
            // Since AddressCapture passes {addressLine1, addressLine2, city, region, postalCode, country}
            // and ManualAddressForm uses {line1, line2, city, state, postcode, country}
            // The mapping differs slightly. 

            // A simple flag from the child component would be better, but given we can't easily refactor
            // all that state without rippling up, we can assume if it's got 'region' it came from AddressCapture.
            // Let's verify manually only if needed. Or verify always but skip on 100% match.
            // Actually, the PR comment explicitly says "If the user selected their address via AddressCapture... 
            // this fires a second paid Cleansing API call unnecessarily".
            // Let's just assume `addressData.region` implies it came from AddressCapture, 
            // OR if it has a specific flag we add in AddressSelected.

            // const isFromCapture = !!addressData.region;

            // if (!isFromCapture) {
            //     const verificationResult = await verifyAddress(addressData);

            //     if (!verificationResult.isValid) {
            //         setVerificationErrors(verificationResult.errors || {});
            //         setIsVerifying(false);
            //         return;
            //     }
            // }

            // Call the parent callback with complete data
            if (onContinueToPayment) {
                await onContinueToPayment(completeData);
            }
        } catch (_error) {
            // Fallback: allow continue? Or block?
            // Usually valid to block but let's warn.
            setGeneralError("Address verification failed. Please check your internet connection.");
        } finally {
            setIsSubmitting(false);
            // setIsVerifying(false);
        }
    };

    return (
        <div className="w-full">
            <h1 className="font-aleo font-semibold text-[26px] leading-[32px] text-[#182230] mb-[4px]">Billing details</h1>
            <p className="font-noto font-normal text-[14px] text-[#667085] leading-[24px] mb-[32px]">Choose your payment method to complete your purchase.</p>

            <div className="mb-8">
                <YourDetails
                    onDataChange={setYourDetailsData}
                    initialData={initialData}
                    onValidityChange={setIsYourDetailsValid}
                    addressData={addressData}
                    markPhoneTouched={markPhoneTouched}
                    onInteraction={handleInteraction}
                />
            </div>

            <div className="mb-4">
                <BillingAddressForm
                    onValidityChange={setIsAddressValid}
                    onAddressChange={setAddressData}
                    // errors={verificationErrors}
                    onClearErrors={() => {
                        // setVerificationErrors({});
                        setGeneralError(null);
                    }}
                    initialAddress={initialData}
                    onInteraction={handleInteraction}
                />
            </div>

            {generalError && (
                <div className="mb-4 text-red-500 text-sm font-noto">
                    {generalError}
                </div>
            )}

            <div className="flex justify-end pt-0">
                <Button
                    variant="primary"
                    className="w-full h-[48px] px-[20px] rounded-[6px] flex items-center justify-center gap-[6px] font-noto !font-bold !text-[14px] leading-[20px] bg-[#030407] text-white hover:bg-black disabled:!bg-[#EAECF0] disabled:!text-[#667085] disabled:opacity-100 disabled:cursor-pointer border-none"
                    disabled={!isAddressValid || !isYourDetailsValid}
                    onClick={handleContinueToPayment}
                >
                    <img
                        src={!isAddressValid || !isYourDetailsValid ? disabledCardIcon : cardIcon}
                        alt="Card"
                        className="w-5 h-5"
                    />
                    <span>Continue to payment</span>
                </Button>
            </div>
        </div>
    );
};

export default BillingDetails;
